import {GET_BRANDS, GET_MATERIAL, GET_BEST_SELLERS, GET_NEW_ARRIVALS, GET_MATERIAL_ERR, GET_MATERIALS, GET_MATERIALS_ERR, FILTER_MATERIALS, COUNT_MATERIALS, SET_SORT, POST_COMMENT_MATERIAL, POST_RATE_MATERIAL, SET_PAGE, GET_TOP_BRAND_MATERIALS, DELETE_COMMENT, GET_TRENDY_PRODUCTS, GET_COMMENT_ORDER, SET_FILTER_TOSHOW,
    GET_PROMOTION_SECTION, GET_PROMOTION_SECTION_1, GET_PROMOTION_SECTION_2, GET_PROMOTION_SECTION_3, GET_PROMOTION_SECTION_4, GET_PROMOTION_SECTION_5, GET_PROMOTION_SECTION_6, GET_PROMOTION_SECTION_7, GET_PROMOTION_SECTION_8, GET_PROMOTION_SECTION_9, GET_PROMOTION_SECTION_10, TEST_PRO} from '../actions/material/type';

const initState = {brands: [], materials: [], best_materials: [], new_materials: [], filter: {}, filterToShow: [], page: 1, pageBrand: null, hasMore: false, material: null, material_err: null, countMatByCat: [], sort: {value: "new_arrivals"}, postComment: null, postRate: null, top_brand_products: null, trendy_materials: [], deleteResult: null, promotionProducts: [], promotion_section: []};
export default function(state = initState, action) {
    switch(action.type) {
        case GET_BRANDS: 
            return {...state, brands: action.payload};
        case GET_MATERIAL:
            return { ...state, material: action.payload };
        case GET_BEST_SELLERS:
            return { ...state, best_materials: action.payload.data };
        case GET_NEW_ARRIVALS:
            return { ...state, new_materials: action.payload.data };
        case GET_MATERIAL_ERR:
            return { ...state, material: null, material_err: action.payload };
        case GET_MATERIALS:
            return { ...state, materials: action.payload.data, hasMore: action.payload.hasMore, materials_count: action.payload.count };
        case GET_MATERIALS_ERR:
            return { ...state, material_err: action.payload, materials: [], materials_count: 0 };
        case GET_TRENDY_PRODUCTS:
            return { ...state, trendy_materials: action.payload.data };
        case FILTER_MATERIALS:
            return { ...state, filter: action.payload };
        case SET_FILTER_TOSHOW:
            return { ...state, filterToShow: action.payload};
        case COUNT_MATERIALS:
            return { ...state, countMatByCat: action.payload };
        case SET_SORT:
            return { ...state, sort: action.payload };
        case POST_COMMENT_MATERIAL:
            return { ...state, postComment: action.payload };
        case POST_RATE_MATERIAL:
            return { ...state, postRate: action.payload };
        case SET_PAGE:
            return { ...state, page: action.payload.page, pageBrand: action.payload.brand };
        case GET_TOP_BRAND_MATERIALS:
            return { ...state, top_brand_products: action.payload }
        case DELETE_COMMENT:
            return { ...state, deleteResult: action.payload}
        case GET_COMMENT_ORDER:
            const {so_no, mat_var_id, payload} = action
            const newCommentOrder = Object.assign({}, state.orderComment)
            if (newCommentOrder[so_no]) {
                newCommentOrder[so_no][mat_var_id] = payload
            } else {
                newCommentOrder[so_no] = {[mat_var_id]: payload}
            }
            
            // newCommentOrder[action.so_no][action.mat_var_id] = action.payload
            return { ...state, orderComment: newCommentOrder}
        case GET_PROMOTION_SECTION: 
            return { ...state, promotion_section: action.payload}
        case GET_PROMOTION_SECTION_1: 
            return { ...state, promotion_section1: action.payload}
        case GET_PROMOTION_SECTION_2:
            return { ...state, promotion_section2: action.payload}
        case GET_PROMOTION_SECTION_3:
            return { ...state, promotion_section3: action.payload}
        case GET_PROMOTION_SECTION_4: 
            return { ...state, promotion_section4: action.payload}
        case GET_PROMOTION_SECTION_5:
            return { ...state, promotion_section5: action.payload}
        case GET_PROMOTION_SECTION_6:
            return { ...state, promotion_section6: action.payload}
        case GET_PROMOTION_SECTION_7: 
            return { ...state, promotion_section7: action.payload}
        case GET_PROMOTION_SECTION_8:
            return { ...state, promotion_section8: action.payload}
        case GET_PROMOTION_SECTION_9:
            return { ...state, promotion_section9: action.payload}
        case GET_PROMOTION_SECTION_10:
            return { ...state, promotion_section10: action.payload}
        case TEST_PRO :
            return { ...state, test_pro: action.payload}
        default:
            return { ...state }
    }
}
